<!-- eslint-disable -->
<template lang="pug">
    .play-box(
        v-if='(!isOlympiad || (isOlympiad && !gameEnd)) && parameters',
    )
        modal-frame-for-individual-settings(
            v-if="showModalFrame",
            @close="showModalFrame = false",
            :player-name="parameters && parameters.playerName",
            :current-user-position="place - 1",
            @parametersUpdate="handleParametersUpdate",
            :slug="type",
        )
        .mult-div__trainer-loader(v-if='isSingleScreen && !isSoundsLoaded')
            progress(:value='this.loadedSound/this.soundObjects.length * 100' max='100')
                | {{ this.loadedSound / this.soundObjects.length * 100 }}%
            |   {{ $i18n.t('trainer.trainer_gamePlayBox_gameLoading') }}
        template(v-else)
            game-header(
                v-if="!inPuzzle && !isBattle",
                :answers='answers'
                :time="playersNumber > 1 ? '' : getTime"
                :slug='type'
                :is-single-screen="isSingleScreen"
                :game-type='parameters && parameters.courseType'
                :is-game-paused="isGamePaused"
                :players-number="playersNumber"
                :color-for-student="colorForStudent"
                :index-of-play-box="place - 1"
                :game-end="gameEnd"
                @soundStateChanged="headerKey = !headerKey"
                :key="headerKey"
                :is-homework="!!exerciseId"
            )
            .play-box__game
                svg-icon.pause-icon(v-if="isGamePaused", name="pause" height="50px" width="50px")
                .mult-div__container_body(v-else)
                    example(
                        :remainder="parameters.remainder"
                        :key="parametersChangerCounter"
                        v-if='!gameEnd && (startGame || isBattle)'
                        :example='example'
                        @answer='checkAnswer'
                        :check-multiplayer-answers='checkMultiplayerAnswers'
                        :dictation='parameters.dictation'
                        :numbers='!!parameters.numbers.length'
                        :players-number="playersNumber"
                        :color-for-student="colorForStudent"
                        :is-battle="isBattle"
                        :correct="correct"
                        :start-game="startGame"
                        :time-for-answer-is-off="timeForAnswerIsOff"
                    )
                    .mult-div__show-answer-button(v-else-if='ableToShowButton')
                        img.mult-div__answer-turtle(:src="turtle")
                        cs-button(@click='showAnswer' v-focus='')
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_showAnswers') }}
                    mult-and-div-examples-viewer(
                        v-else-if='parameters.dictation'
                        :examples-array='examplesArray'
                        :numbers='!!parameters.numbers.length'
                        :is-remainder-on="isRemainderOn"
                    )
                    result(
                        v-else-if="!isBattle"
                        @restart='refreshGame'
                        :answer='answer'
                        :exercise-id='exerciseId'
                        @clearAnswer='clearAnswer'
                        :right-answer='rightAnswer'
                        :right-remainder='rightRemainder'
                        :game-end='gameEnd'
                        :place='place'
                        :is-single-screen='isSingleScreen'
                        :show-problem="showProblem"
                        @showProblem="showProblem = $event"
                        :is-olympiad="isOlympiad"
                        :example='example'
                        :dictation='parameters.dictation'
                        :numbers='!!parameters.numbers.length'
                        :color-for-student="colorForStudent"
                        :players-number="playersNumber"
                        :show-answer="parameters.showAnswer"
                        :is-time-over="isTimeOver"
                        :answers="answers"
                    )
                        slot
                .game-info__container
                    .game-info__block
                        game-info(
                            v-if="!gameEnd && (startGame || isGamePaused || playersNumber > 1 || isBattle)",
                            :score="{left: !isBattle ? answers.good : userScore, right: !isBattle ? answers.bad : opponentScore}",
                            :time="getTime",
                            :time-with-hours="getTimeWithHours",
                            :multiplayer-mode="playersNumber >= 1",
                            :player-name="parameters && parameters.playerName",
                            :players-number="playersNumber",
                            :place="place",
                            :color-for-student="colorForStudent",
                            @openModalFrame="showModalFrame = true",
                            :is-game-paused="isGamePaused",
                            :is-olympiad="isOlympiad",
                            :slug="type",
                            @parametersUpdate="handleParametersUpdate",
                            :is-from-battle="isBattle",
                            :parameters="parameters",
                            :opponent="opponent",
                            :opponent-numbers="opponentNumbers",
                            :is-opponent-answering="isOpponentAnswering",
                            :game-allows-tips="true"
                        )
</template>

<script>
    const AVAILABLE_ANSWERS_DIRS = ['ru', 'fr'];
    const SECONDS_IN_MINUTE = 60;

    import MultiplayerPlayBoxMixin from '../../../../utils/multiplayer/playBoxMixin';
    import trainerConfig from '../../../../config/trainer';
    import GameMixin from '../../../../utils/trainer/game';
    import Example from './Example.vue';
    import Result from './Result.vue';
    import timer from '../../../../utils/trainer/timer';
    import GameHeader from '../../GameHeader.vue';
    import answerDurationMixin from '../../../../utils/trainer/answerDurationMixin';
    import EndGameMixin from '../utils/endGame';
    import _ from 'lodash';
    import MultAndDivExamplesViewer from '../MultAndDivExamplesViewer.vue';
    import GameInfo from '../GameInfo.vue';
    import Battle from '../../../../utils/battle/battleMixin';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';

    export default {
        props: {
            exerciseId: {
                type: Number,
                default: 0,
            },
            type: {
                type: String,
                default: '',
            },
            gameType: {
                type: String,
                default: '',
            },
            playAgain: {
                type: Boolean,
                default: false,
            },
            inPuzzle: {
                type: Boolean,
                default: false,
            },
            isLastGameInBattle: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                answers: {
                    good: 0,
                    bad: 0,
                },
                parameters: null,
                example: null,
                prevMultiplicationExample: {
                    left: null,
                    right: null,
                    isChangingMultipliers: false,
                },
                prevDivisionExample: {
                    left: null,
                    right: null,
                    isChangingMultipliers: false,
                },
                answer: null,
                rightAnswer: null,
                rightRemainder: null,
                isRemainderOn: false,
                startGame: false,
                gameEnd: false,
                correct: null,
                answerTimer: null,
                answerTime: 0,
                examplesArray: [],
                ableToShowButton: false,
                ableToShowAnswers: false,
                examplesPlayed: 0,
                loadedSound: 0,
                isSoundsLoaded: false,
                headerKey: false,
                showProblem: false,
                infinityModeCompleted: false,
            };
        },
        mixins: [GameMixin, timer, answerDurationMixin, EndGameMixin, Battle, MultiplayerPlayBoxMixin],
        beforeDestroy() {
            if (!this.inPuzzle) {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
            }
            this.beforeTabClosed();
            window.removeEventListener('beforeunload', this.beforeTabClosed);
        },
        created() {
            window.addEventListener('beforeunload', this.beforeTabClosed);
        },
        mounted() {
            this.fetchData().then(() => {
                if (!this.isSingleScreen) {
                    this.isGamePaused = true;
                } else if (this.soundObjects) {
                    this.$createjs.Sound.removeAllEventListeners();
                    this.$createjs.Sound.addEventListener('fileload', this.soundLoad);
                    this.$createjs.Sound.alternateExtensions = ['mp3'];
                    this.$createjs.Sound.registerSounds(this.soundObjects);
                }
                this.generateExample();
            });
        },
        watch: {
            gameEnd(val) {
                if (val) {
                    this.$emit('playAgainReady', !this.isSingleScreen);
                    if (this.inPuzzle) {
                        this.$emit('finish', this.answers, this.time, this.example);
                    }
                }
            },
            example: {
                handler(val) {
                    if (val && this.parameters.dictation) {
                        this.startGame = false;
                        if (this.examplesPlayed === 1) {
                            this.time--;
                        }
                        this.$nextTick(() => (this.startGame = true));
                    }
                },
                deep: true,
            },
            isTimeOver(val) {
                if (val) {
                    this.gameEnd = true;
                    if (!this.isBattle) {
                        this.sendStat(false);
                        this.$toasted.info(this.$i18n.t('trainer.trainer_gamePlayBox_gameCompleted'));
                        this.$emit('finish', this.answers, this.time, this.example);
                        this.checkAnswer(this.answer);
                    } else {
                        this.sendStat(false);
                    }
                }
            },
            correct(val) {
                if (this.isSingleScreen) {
                    this.$emit('playAgainReady', val !== null);
                } else {
                    let playBox = document.querySelectorAll('.play-box')[this.place - 1].parentElement;
                    if (playBox) {
                        if (val !== null && val) {
                            playBox.classList.add('play-box__correct-answer');
                        } else if (val !== null && !val) {
                            playBox.classList.add('play-box__incorrect-answer');
                        } else if (val === null) {
                            playBox.classList.remove('play-box__correct-answer');
                            playBox.classList.remove('play-box__incorrect-answer');
                        }
                    }
                }
            },
            startGame(val) {
                if (this.parameters && this.parameters.dictation && !val) {
                    return;
                }
                val ? this.setTimer() : this.stopTimer();
                this.$emit('checkAnswersReady', { status: val, playerPosition: this.place });
            },
            playAgain(val) {
                if (val && this.answers.good < this.parameters.amountOfExamples && !this.startGame) {
                    this.refreshGame();
                }
            },
            multiplayerGamesState(value) {
                if (value && !this.gameEnd) {
                    this.isGamePaused = value === 'paused';
                }
            },
            isGamePaused(value) {
                if (!value) {
                    this.continue();
                } else {
                    this.startGame = false;
                    this.stopTimer();
                }
                let playBox = document.querySelectorAll('.play-box')[this.place - 1]?.parentElement;
                if (playBox) {
                    playBox.classList.remove('play-box__correct-answer');
                    playBox.classList.remove('play-box__incorrect-answer');
                }
            },
            refreshGameEvent: {
                handler() {
                    this.resetGameResult();
                },
                immediate: true,
            },
            continueGameEvent(val) {
                if (val && this.answers.good < this.parameters.amountOfExamples && !this.startGame) {
                    this.refreshGame();
                }
            },
            parametersChangerCounter() {
                if (!this.gameEnd) {
                    this.time = 0;
                    this.correct = null;
                }
                this.fetchData().then(this.generateExample);
            },
        },
        methods: {
            resetGameResult() {
                if (!this.isSingleScreen) {
                    this.isGamePaused = true;
                }
                this.answers.good = 0;
                this.answers.bad = 0;
                this.correct = null;
                this.examplesArray = [];
                this.showProblem = false;
                this.answer = null;
                this.gameEnd = false;
                this.stopTimer();
                this.time = 0;
                clearInterval(this.answerTimer);
                this.answerTime = 0;
                this.$root.playAgainReadyScreens = 0;
                this.$root.checkAnswersReadyScreens = 0;
            },
            startAnswerTimer() {
                this.answerTimer = setInterval(() => {
                    if (this.startGame || this.parameters.dictation) {
                        this.answerTime++;
                        if (this.answerTime === this.parameters.timeForAnswer) {
                            if (this.parameters.dictation) {
                                this.ableToShowAnswers = false;
                            } else {
                                this.checkAnswer(this.answer);
                                this.startGame = false;
                                return;
                            }
                            this.refreshGame();
                        }
                    }
                }, 1000);
            },
            soundLoad() {
                this.loadedSound++;
                if (this.loadedSound === this.soundObjects.length) {
                    this.isSoundsLoaded = true;
                    this.continue();
                }
            },
            continue() {
                if (!this.isGamePaused) {
                    this.startGame = true;
                }
                if ((this.parameters.dictation || this.parameters.timeForAnswer !== '-1') && !this.isOlympiad) {
                    this.startAnswerTimer();
                }
                this.trackTime();
            },
            clearAnswer() {
                this.answer = null;
            },
            checkAnswer(answer) {
                this.isOpponentAnswering = true;
                this.answer = +answer;
                if (this.example.operation === '*') {
                    this.rightAnswer = this.example.left * this.example.right;
                } else {
                    this.rightAnswer = this.example.left / this.example.right;
                }
                let precision = 0;
                this.rightAnswer = +this.rightAnswer.toFixed(precision);
                if (typeof answer === 'object' && answer !== null) {
                    this.answer = _.cloneDeep(answer);
                    if (
                        this.answer.quotient === this.rightAnswer &&
                        this.answer.givenRemainder === this.rightRemainder
                    ) {
                        this.correct = true;
                        this.answers.good++;
                        if (
                            !this.isOlympiad &&
                            !this.isBattle &&
                            this.answers.good >= this.parameters.amountOfExamples &&
                            !this.parameters.infinityAmountOfExamples
                        ) {
                            this.gameEnd = true;
                        }
                    } else {
                        this.correct = false;
                        this.answers.bad++;
                    }
                } else {
                    this.answer = +this.answer;
                    if (this.answer === this.rightAnswer) {
                        this.correct = true;
                        this.answers.good++;
                        if (
                            !this.isOlympiad &&
                            !this.isBattle &&
                            this.answers.good >= this.parameters.amountOfExamples &&
                            !this.parameters.infinityAmountOfExamples
                        ) {
                            this.gameEnd = true;
                        }
                    } else {
                        this.correct = false;
                        this.answers.bad++;
                    }
                }
                this.stopTracking();
                if (
                    (this.isOlympiad || this.isBattle) &&
                    this.answers.good + this.answers.bad >= this.parameters.amountOfExamples
                ) {
                    this.gameEnd = true;
                }
                if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                    this.sendStat(this.correct);
                }
                if (this.isOlympiad) {
                    this.refreshGame();
                } else {
                    this.startGame = false;
                }
            },
            refreshGame(playAgain = false) {
                if (playAgain) {
                    this.resetGameResult();
                    this.gameStat = null;
                    this.fetchData();
                }
                if (this.parameters.dictation || this.parameters.timeForAnswer !== '-1') {
                    this.examplesPlayed++;
                    this.correct = null;
                    clearInterval(this.answerTimer);
                    this.answerTime = 0;
                    this.parameters.remainder ? (this.isRemainderOn = true) : (this.isRemainderOn = false);
                    this.examplesArray.push(_.cloneDeep(this.example));
                    this.startGame = false;
                    if (this.examplesPlayed >= this.parameters.amountOfExamples && this.parameters.dictation) {
                        this.ableToShowButton = true;
                        this.gameEnd = true;
                    } else if (
                        this.answers.good === this.parameters.amountOfExamples &&
                        !this.parameters.infinityAmountOfExamples
                    ) {
                        this.gameEnd = true;
                    } else {
                        this.generateExample();
                        this.continue();
                    }
                    if (!this.ableToShowButton) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    return;
                }
                this.showProblem = false;
                this.answer = null;
                this.correct = null;
                this.generateExample();
                this.startGame = true;
                this.isOpponentAnswering = false;
                this.trackTime();
            },
            showAnswer() {
                this.ableToShowAnswers = true;
                this.ableToShowButton = false;
                clearTimeout(this.timer);
                this.timer = null;
            },
            beforeTabClosed() {
                if (
                    (this.startGame || (!this.startGame && !this.gameEnd && this.correct !== null)) &&
                    this.user.type === 'student' &&
                    !this.isBattle
                ) {
                    this.gameEnd = true;
                    this.infinityModeCompleted = true;
                    this.sendStat(true);
                }
                return null;
            },
            generateExample() {
                const operations = [];
                for (let key in this.parameters.operations) {
                    this.parameters.operations[key] && operations.push(key);
                }
                operations[Math.floor(Math.random() * operations.length)] === 'multiply'
                    ? this.generateMultiplication()
                    : this.generateDivision();
            },
            generateMultiplication() {
                let right;
                let left;
                const prevExample = this.prevMultiplicationExample;
                do {
                    right = this.generateOperand();
                    left = this.allPossibleNumbers[Math.floor(Math.random() * this.allPossibleNumbers.length)];
                    if (this.parameters.changingMultipliers && !prevExample.isChangingMultipliers) {
                        [right, left] = [left, right];
                    }
                    this.prevMultiplicationExample = {
                        left,
                        right,
                        isChangingMultipliers: this.parameters.changingMultipliers
                            ? !prevExample.isChangingMultipliers
                            : false,
                    };
                } while (
                    left === prevExample.left ||
                    (!this.parameters.changingMultipliers &&
                        this.parameters.numbers.length > 1 &&
                        right === prevExample.right)
                );
                this.example = { left, right, operation: '*' };
            },
            generateDivision() {
                let right;
                let left;
                const prevExample = this.prevDivisionExample;
                if (this.parameters.selfDivision) {
                    do {
                        left = right = this.generateOperand();
                    } while (
                        this.parameters.numbers.length > 1 &&
                        right === prevExample.right
                    )
                    this.example = { left, right, operation: '/' };
                    this.prevDivisionExample = {
                        left,
                        right,
                        isChangeMultipliers: false,
                    };
                    return;
                }
                if (!this.parameters.changingMultipliers || this.prevDivisionExample.isChangeMultipliers) {
                    do {
                        right = this.generateOperand();
                        left =
                            right * this.allPossibleNumbers[Math.floor(Math.random() * this.allPossibleNumbers.length)];
                        this.prevDivisionExample = {
                            left,
                            right,
                            isChangeMultipliers: false,
                        };
                    } while (
                        left === prevExample.left ||
                        (!this.parameters.selfDivision && left === right) ||
                        (!this.parameters.changingMultipliers &&
                            this.parameters.numbers.length > 1 &&
                            right === prevExample.right)
                    );
                } else {
                    left = this.generateOperand();
                    right = this.getRandomRightForDivisionAndChangingMultipliers(left);
                    this.prevDivisionExample = {
                        left,
                        right,
                        isChangeMultipliers: true,
                    };
                }
                this.example = { left, right, operation: '/' };
            },
            getRandomRightForDivisionAndChangingMultipliers(number) {
                const arr = [1];
                if (this.parameters.selfDivision) {
                    arr.push(number);
                }
                for (let index = 2; index < number; index++) {
                    if (!(number % index)) arr.push(index);
                }
                return arr[Math.floor(Math.random() * arr.length)];
            },
            generateOperand() {
                return this.parameters.numbers[Math.floor(Math.random() * this.parameters.numbers.length)];
            }
        },
        computed: {
            timeForAnswerIsOff() {
                return this.parameters.timeForAnswer === -1;
            },
            soundObjects() {
                if (!this.isSingleScreen) {
                    return;
                }
                return trainerConfig.result;
            },
            locale() {
                if (this.user && this.user.locale) {
                    return this.user.locale;
                }
                return 'ru';
            },
            turtle() {
                if (AVAILABLE_ANSWERS_DIRS.includes(this.locale)) {
                    return require(`../../../../assets/images/turtle/${this.locale}/${this.locale}_AnswerTurtle.svg`);
                }
                return require(`../../../../assets/images/turtle/ru/ru_AnswerTurtle.svg`);
            },
            isOlympiad() {
                return this.gameType === 'olympiad';
            },
            isSingleScreen() {
                return !this.playersNumber;
            },
            isTimeOver() {
                return (
                    this.parameters &&
                    Boolean(this.parameters.timeLimit) &&
                    this.time >= this.parameters.timeLimit * SECONDS_IN_MINUTE
                );
            },
            allPossibleNumbers() {
                const arr = Array.from(Array(11), (_, i) => i);
                return this.parameters.operations.divide ? arr.slice(1) : arr;
            },
        },
        components: {
            Example,
            Result,
            GameHeader,
            MultAndDivExamplesViewer,
            GameInfo,
            CalculatingAnswers,
        },
    };
</script>

<style scoped lang="scss">
    @import '@/assets/sass/games/playbox.scss';

    .mult-div__show-answer-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include inset-space($space-base);
    }

    .mult-div__answer-turtle {
        max-width: 180px;
        @include stack-space($space-base);
        @include media($xlg) {
            max-width: 240px;
        }
    }

    .mult-div__prepare-container {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;
        justify-content: center;
        align-items: center;
        @include inset-space($space-base);
    }

    .mult-div__prepare-text {
        font-family: Boomboom, serif;
        color: $color-brown-500;
        font-size: 30px;
        white-space: nowrap;

        @include media($sm) {
            font-size: 60px;
        }
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        align-items: center;
        flex-direction: column-reverse;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .pause-icon {
        color: $x-color-white;
        background-color: $hsl-color-blue-56_5;
        border-radius: 50%;
    }

    .mult-div__container_body {
        display: flex;
        flex-grow: 1;
        justify-content: center;
    }

    .mult-div__trainer-loader {
        @include make-col(8, 12, 0);
        @include make-offset(2, 12);
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        height: 100%;
    }

    .mult-div__divider {
        border-bottom: 1px solid $color-grey-300;
    }

    .game-info {
        align-self: flex-start;
    }

    .game-info__container {
        display: flex;
        align-self: start;
        flex-direction: column;
        margin-bottom: 20px;
        width: 100%;
        @include media($lg) {
            width: auto;
        }
    }

    .game-info__block {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        align-self: center;
        @include media($lg) {
            align-self: flex-start;
        }
    }
</style>

<style lang="scss" scoped>
    .multiplayer .play-box__game {
        height: 100%;
        flex-direction: column-reverse;
        justify-content: flex-end;
        align-items: center;
    }

    .multiplayer .game-info__container {
        align-self: auto;
    }

    .multiplayer .mult-div__container_body {
        width: 100%;
    }
</style>
